import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.shouldRender)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass([[$setup.isActive ? 'bg-success-50 text-success-700' : 'bg-danger-100 text-danger-700'], "inline-flex rounded-full px-2 font-semibold"])
      }, _toDisplayString($setup.isActive ? _ctx.$t('core.options.Active') : _ctx.$t('core.options.Inactive')), 3 /* TEXT, CLASS */))
    : _createCommentVNode("v-if", true)
}